import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.PostingAccount.List.IRequest;
type Response = Api.Core.PostingAccount.List.IResponse;
type Headers = Api.Core.PostingAccount.List.IHeaders;
const url = '/api/Finance/LedgerAccount';
export default async function postingAccountListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
